export * from './src/restaurants-v3-order-orders.meta.js';
